import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { KeyboardArrowDownIcon } from '~/@components/Icon';

export const PaginationSelectIcon: FC<SvgIconProps> = props => <KeyboardArrowDownIcon {...props} fontSize="small" />;
